module.exports = __webpack_public_path__ + "img/picture_icon.1a212eda.png";